import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CoreProvider } from './core';

@Injectable({ providedIn: 'root' })
export class NavServiceProvider {

  public navc: NavController = null;
  private core: CoreProvider;

  init(navigation: NavController, core: CoreProvider) {
    this.navc = navigation;
    this.core = core;
  }

  setBackButtonAction(navBar) {
    navBar.backButtonClick = () => {
      this.navc.pop();
    };
  }

  openClient = (uuid: string) => this.navc.navigateForward(['/crm/client', uuid, 'edit']);
  openOrder = (uuid: string) => this.navc.navigateForward(['/orders', uuid, 'detail']);
  openInvoice = (uuid: string) => this.navc.navigateForward(['/billing/invoice', uuid, 'edit']);
  openCms = (uuid: string) => this.navc.navigateForward(['/cms', uuid, 'edit']);

}
